import {
  patchWithServerId,
  unlisten,
  unlistenAll,
} from "shared/middleware/waitForId/waitForIdSlice";

const waitForIdMiddleware = (store) => (next) => (action) => {
  const state = store.getState();
  listen({ store, action, state: state.waitForId });
  clearListening({ store, action, state });
  next(action);
};

function listen({ store, action, state }) {
  const listenedToActions = state.listenedToActions;
  const unsavedIds = listenedToActions[action.type];
  if (unsavedIds) {
    console.log("unsavedIds in middleware: ", unsavedIds);
    const effect = unsavedIds[action.meta.localId];
    if (effect) {
      try {
        store.dispatch(patchWithServerId(effect, action.payload.id));
        store.dispatch(unlisten(action.type, action.meta.localId));
      } catch (error) {
        debugger;
      }
    }
  }
}

function clearListening({ store, action, state }) {
  if (
    action.type === "Offline/BUSY" &&
    action.payload.busy === false &&
    state.offline.outbox.length === 0
  ) {
    store.dispatch(unlistenAll());
  }
}

export default waitForIdMiddleware;
